module.exports = __webpack_public_path__ + "static/media/user-guide-8.6f6decb6.png";